import { render, staticRenderFns } from "./UserRecharge.vue?vue&type=template&id=50cdfdfc&scoped=true"
import script from "./UserRecharge.vue?vue&type=script&lang=js"
export * from "./UserRecharge.vue?vue&type=script&lang=js"
import style0 from "./UserRecharge.vue?vue&type=style&index=0&id=50cdfdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cdfdfc",
  null
  
)

export default component.exports